import { CREW_STATUS } from '../types/crew';

type WithStatus = { status: string };

// CRM-12 : les équipages archivés (doublons, expirés) ne comptent dans
// aucune statistique. Les listes/vues, elles, continuent de les afficher.
export function excludeArchived<T extends WithStatus>(crews: T[]): T[] {
  return crews.filter((c) => c.status !== CREW_STATUS.ARCHIVED);
}
